import { Component, Input, OnInit } from '@angular/core';
import { IShortSPDetail } from 'src/app/interface/service.interface';
import { TripService } from 'src/app/services/trip/trip.service';

@Component({
  selector: 'app-splash-loading',
  templateUrl: './splash-loading.component.html',
  styleUrls: ['./splash-loading.component.scss']
})
export class SplashLoadingComponent {
  @Input() detailFetched: boolean = false;
  @Input() spDetail!: IShortSPDetail;
  imageLoaded: boolean = false;
}
